// extracted by mini-css-extract-plugin
module.exports = {"link-button":"LinkButton_link-button__j6LkW"};